import { Component, OnInit } from '@angular/core';
import { ToolsService } from './../../Service/Tools/tools.service'
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-tools',
  templateUrl: './tools.component.html',
  styleUrls: ['./tools.component.css']
})
export class ToolsComponent implements OnInit {
  SelfServeArray=[];
  selectedSelfServes:string;
  toolData=[];
  imageFolder:string;
  constructor(private _toolService: ToolsService) 
  {
    this.imageFolder=environment.imageFolder;
   }

  ngOnInit() {
    this.GetHomeContent();
  }


  GetHomeContent(){
    this._toolService.GetTools().subscribe(
    res =>{
      if (res.isSuccess) 
      {    
        console.log(res);         
        this.toolData = res.responseData;
      //  this.SelfServeArray=JSON.parse(res.responseData.selfServe); 
       // console.log(this.SelfServeArray,"selfserve");
      ////   this.data.push(this.homeData.selfServe)
      //   if( this.homeData.selfServe!=null && this.data[0]!="[]" )
      //   {
      //     this.SelfServeArray=JSON.parse(this.homeData.selfServe);       
      //       this.selectedSelfServes=this.SelfServeArray[0].value;      
      //   }                   
      // }else{
      //   return false;
      // }
    }
  }
    )
  }
}
